import AddressBlock from '@app/components/AddressBlock'
import { IComp } from '@app/models/Comp'
import { formatCurrency, formatDate } from '@app/utils/formatting'
import * as React from 'react'
import { Card, CardBody, CardTitle } from 'reactstrap'

interface ICompCardProps {
  actions?: React.ReactNode
  comp: IComp
}

export default class CompCard extends React.PureComponent<ICompCardProps> {
  public render() {
    return (
      <Card>
        <CardBody>
          <div className='d-flex justify-content-between'>
            <CardTitle>
              {this.props.comp.lastSaleDate
                ? formatDate(this.props.comp.lastSaleDate, 'MM/DD/YYYY')
                : 'Unknown'}
              <span> - </span>
              {formatCurrency(this.props.comp.lastSalePrice || 0)}
            </CardTitle>
            <div> {this.props.actions} </div>
          </div>
          <div>{this.props.comp.propertyName}</div>
          <AddressBlock address={this.props.comp.propertyAddress} />
        </CardBody>
      </Card>
    )
  }
}
